export default "data:image/webp;base64,UklGRjIAAABXRUJQVlA4TCUAAAAvJ0AHACDMNqKezjkdWn9iwWRc+WN1CAQSi/iGHaz/OXF8HDUHAA=="